module.exports = __webpack_public_path__ + "static/media/qixingshanicon.e2127837.webp";